export function getIndexBy(array: Array<{}>, { name, value }): number {
  for (let i = 0; i < array.length; i++) {
    if (array[i][name] === value) {
      return i;
    }
  }
  return -1;
}

export function sanitizeQuillText(content: string): string {
  return content.replace(/&nbsp;/g, ' ').trim();
}
